import React, { useEffect, useState, useMemo, useContext } from "react";
import { useSelector, useDispatch } from 'react-redux';
// import { getList as getRequests } from '../redux/actions/requestsActions';
import { Col, Row, Container, Tabs, Tab, Badge } from "react-bootstrap";
import { formatDistanceToNow } from 'date-fns'
import { es, enUS } from 'date-fns/locale';
import { NavLink, useLocation } from 'react-router-dom';
import { serviceTypeIcon } from '../globals';
import Screen from '../components/Screen';
import { T } from "react-translator-component";
import { i18nValue, invertDate } from '../functions';
import { UserContext } from "../context/user";
import { HotelContext } from "../context/hotel";

const Requests = () => {
  const [ initialTab, setInitialTab ] = useState('actives')
  const { sectionsByCode } = useContext(HotelContext);
  const { requests, activeRequests, getRequests, language } = useContext(UserContext);
  const { pathname } = useLocation();

  useEffect(() => {
    getRequests();
  }, [])
  
  const requestByStatus = useMemo(() => {
    let _r = { actives: activeRequests(), inactives: [] };
    if (!requests) return _r;
    _r.inactives = requests.filter(item => !_r.actives.some(i => item.id === i.id));
    return _r;
  }, [requests])

  const _requestItem = (item) => {
    item.status = item.status ?? 'pending'; // TODO... parche para el null

    const _createdAt = Date.parse(item.createdAt);
    const _ago = _createdAt ? formatDistanceToNow(_createdAt, { addSuffix: true, locale: language === 'es' ? es : enUS }) : null;

    let _data = {}
    let _cart = {}
    try {
      _data = item.data;
      _cart = item.cart ?? {};
    } catch (error) {
      console.error(error)
    }
    _data = _data || {};
    _cart = _cart || {};
      
    let _lblInfo = null;
    let _lblDesc = null;
    let _lblExtraDesc = null;
    if (item.type == 'room_supplies' || item.type == 'room_service' || item.type == 'pressing' || item.type == 'laundry') {
      const _itemForDesc = [];
      if (_cart) {
        _lblInfo = _cart.qty + ' Producto' + (_cart.qty > 1 ? 's' : '')
        _lblDesc = _cart.desc
      } else if (_data.items) {
        const _k = Object.keys(_data.items);
        if (_k.length > 0) {
          _lblInfo = _k.length + ' Producto' + (_k.length > 1 ? 's' : '')
          _k.map((k) => {
            _itemForDesc.push(_data.items[k] + ' ' + k)
          })
          _lblDesc = _itemForDesc.join(', ');
        }
      }
    }
    if (item.type == 'wakeup_call') {
      const _itemForDesc = [];
      _lblInfo = 'Hora ' + (new Date(_data.date).toLocaleTimeString('es-AR', { hour: "numeric", hour12: "false" }));
      _data.items?.map((it) => {
        _itemForDesc.push(it)
      })
      _lblDesc = 'Avisos: ' + _itemForDesc.join(', ');
    }
    if (item.type == 'services_booking') {
      _lblDesc = `${_data.service?.name ?? 'servicio'}`;
      console.log('0308 _data', _data)
      _lblExtraDesc = `${invertDate(_data.day)} ${_data.hour}hs. - ${_data.qty} persona${_data.qty > 1 ? 's' : ''}`
    }    
    return (
    <NavLink 
        key={item.id} 
        className={"list-group-item list-group-item-action flex-column align-items-start text-decoration-none px-2"} 
        to={{ pathname: item.id}}        
        state={{from: pathname}}
        >        
            <div className="d-flex">
              <div style={{ marginLeft: 3, verticalAlign: 'text-top', flex: '0 0 35px' }}>{serviceTypeIcon(item.type, 25)}</div>
              <div className="mr-auto" style={{ lineHeight: 1 }}>
                <span className="d-block general-text-sm mb-1">{_ago}</span>
                <h6 className="mb-0">{T(`services.type.${item.type}`)}</h6>
                <span className="general-text-sm text-info">{_lblDesc}</span>
                {_lblExtraDesc && <span className="general-text-sm d-block mt-2 text-muted">{_lblExtraDesc}</span>}
              </div>
              <div className="text-right" style={{ flex: '0 0 90px' }}>
                <span className={`d-inline-block label label-sm label-light-${item.status} label-inline text-uppercase`}>{T(`services.status.${item.status}`)}</span>
              </div>
            </div>
        </NavLink>)
  }

  if (!initialTab) {
    return <p>Loading...</p>
  }


  return (
    <Screen
      section="requests"
      title={i18nValue(sectionsByCode['requests'], 'title', language) || "Requests"}
      description={i18nValue(sectionsByCode['requests'], 'desc', language)}
    >
      <Tabs defaultActiveKey={initialTab} transition={false}>
        <Tab tabClassName="request-tab" eventKey="actives" title={<React.Fragment>
            {T('general.active')}{requestByStatus.actives.length > 1 && 's' }
            {requestByStatus.actives.length > 0 && <Badge style={{ fontWeight : 200, marginLeft : 10 }} variant='light'>{requestByStatus.actives.length}</Badge>}
          </React.Fragment>}>
            <div className="list-group">
              {requestByStatus.actives.map(req => (_requestItem(req)))}
            </div>
        </Tab>
        <Tab tabClassName="request-tab" eventKey="inactives" disabled={requestByStatus.inactives.length === 0} title={<React.Fragment>
          {T('general.inactive')}{requestByStatus.inactives.length>1 && 's'}
          {requestByStatus.inactives.length > 0 && <Badge style={{ fontWeight : 200, marginLeft : 10 }} variant='light'>{requestByStatus.inactives.length}</Badge>}
        </React.Fragment>}>
          <div className="list-group">
              {requestByStatus.inactives.map(req => (_requestItem(req)))}
            </div>
        </Tab>
      </Tabs>
    </Screen>
  );
}

export default Requests;